const InitObserver = () => {
  const body = document.body;
  const site = document.querySelector('.entry-content');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        body.classList.remove('scroll-down');
        console.log('xxxx');
      } else {
        body.classList.add('scroll-down');
        console.log('oooo');
      }
    });
  });
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };
  observer.observe(site, options);
  window.addEventListener('DOMContentLoaded', (event) => {});
};
export default InitObserver;
